export default __webpack_public_path__ + "static/media/reactorg.fa35378b.png";